import React, {useRef} from 'react';
import {useSelector} from 'react-redux';
import {useReactToPrint} from 'react-to-print';
import {useTranslation} from 'react-i18next';
import {selectedPresentationSelector, selectedPresentationSlidePreviewsSelector} from '../../../../store/selectors/presentation.selectors';
import Modal from '../../../../incase-domain/components/modals/directory/Modal';

interface ExportToPdfModalProps {
    isOpen: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

function ExportToPdfModal(props: ExportToPdfModalProps): JSX.Element {
    const {isOpen, onCancel, onConfirm} = props;

    const {t} = useTranslation();

    const selectedPresentation = useSelector(selectedPresentationSelector);
    const selectedPresentationPreviews = useSelector(selectedPresentationSlidePreviewsSelector);

    const slidesContainer = useRef<HTMLDivElement>(null);

    const handlePrint = useReactToPrint({
        content: () => slidesContainer.current,
    });

    function handleCancel(): void {
        onCancel();
    }

    function handleConfirm(): void {
        handlePrint();
        onConfirm();
    }

    return (
        <Modal
            isOpen={isOpen}
            size="lg"
            onCancel={handleCancel}
            onConfirm={handleConfirm}
            header={selectedPresentation.name}
            description={t('common.exportToPdf')}
            icon="ph:file-pdf"
            showConfirm
            confirmText={t('common.confirm')}
        >
            <div style={{maxHeight: '65vh', overflowY: 'auto'}} className="u-p-2">
                <div ref={slidesContainer}>
                    {}

                    {selectedPresentation.slides.map((slide) => {
                        const preview = selectedPresentationPreviews.find((item) => item.slideId === slide._id);
                        if (!preview) return null;
                        return <img key={`export-print-preview-${preview.slideId}`} src={preview.imgSrc} alt="slide-preview" />;
                    })}
                </div>
            </div>
        </Modal>
    );
}

export default ExportToPdfModal;
